import { styled } from 'styled-components';

export const Gutter = styled.div`
  height: ${p => p.theme.margin}rem;
`;
